export default function isInputSelected(){
    return [...document.getElementsByTagName('input')].filter(input => input === document.activeElement).length
}

